import Vue from 'vue';
import { contractAddress, nebPay, neb, api } from "../util/nebulas";

const fromAddress = 'n1MHvQ8YLjjM1C2HNC8FYp3PYoxFD8MdxzD';

export default {

    // ************* \\
    // - INIT DATA - \\
    // ************* \\

    initBlockchainData ({ dispatch, commit }) {

        dispatch('initUsers');
        dispatch('initAddress').then(response => {
            dispatch('initGames', { address: response.address });
        });
        dispatch('initTotalEarnings');
             
    },

    initTotalEarnings({ commit }) {
        
        return new Promise((resolve, reject) => {      
            let items = [];
            
            const executeCall = function () {
                api.call({

                    chainID: 1,
                    from: fromAddress,
                    to: contractAddress,
                    value: 0, nonce: 6,
                    gasPrice: 1000000,
                    gasLimit: 2000000,
                    contract: {
                        function: 'getTotalEarnings',
                        args: '',
                    }

                }).then(function(data) {

                    // Catch a bad response
                    if (data.execute_err == 'execution timeout' || data.execute_err == 'contract code syntax error') {

                        console.log('execute_err -- try again');
                        executeCall();

                    } else if (!data.result) {

                        console.log('error', 'users', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                    } else {

                        items = JSON.parse(data.result);     
                        resolve({
                            items: items,
                            message: 'success'
                        });

                    }

                }).catch(error => {

                    console.log(error);
                    console.log('try again');
                    executeCall();

                });
            }

            executeCall();
        
        }).then((returnObject) => {
    
            commit('setTotalEarnings', { items: returnObject.items });

        });

    },

    initAddress ({ commit }) {
        return new Promise((resolve, reject) => { 

            const address =  Vue.localStorage.get('address');
            commit('setAddress', { address });

            resolve({ address });

        });
    },

    initUsers({ commit }) {

        return new Promise((resolve, reject) => {      
            let items = [];
            
            commit('setLoadingUsers', { loading: true });
            const executeCall = function () {
                api.call({

                    chainID: 1,
                    from: fromAddress,
                    to: contractAddress,
                    value: 0, nonce: 6,
                    gasPrice: 1000000,
                    gasLimit: 2000000,
                    contract: {
                        function: 'getUsers',
                        args: '',
                    }

                }).then(function(data) {

                    // Catch a bad response
                    if (data.execute_err == 'execution timeout' || data.execute_err == 'contract code syntax error') {

                        console.log('execute_err -- try again');
                        executeCall();

                    } else if (!data.result) {

                        console.log('error', 'users', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                    } else {

                        items = JSON.parse(data.result);     
                        resolve({
                            items: items,
                            message: 'success'
                        });

                    }

                }).catch(error => {

                    console.log(error);
                    console.log('try again');
                    executeCall();

                });
            }

            executeCall();
        
        }).then((returnObject) => {
    
            commit('setUsers', { items: returnObject.items });
            commit('setLoadingUsers', { loading: true });

        });

    },

    initGames({ commit }, payload) {

        return new Promise((resolve, reject) => {      
            let items = [];
            let userItems = [];

            commit('setLoadingBlockWars', { loading: true });

            const executeCall = function () {
                api.call({

                    chainID: 1,
                    from: fromAddress,
                    to: contractAddress,
                    value: 0, nonce: 6,
                    gasPrice: 1000000,
                    gasLimit: 2000000,
                    contract: {
                        function: 'getGames',
                        args: '',
                    }

                }).then(function(data) {

                    // Catch a bad response
                    if (data.execute_err == 'execution timeout' || data.execute_err == 'contract code syntax error') {

                        console.log('execute_err -- try again');
                        executeCall();

                    } else if (!data.result) {

                        console.log('error', 'games', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                    } else {

                        items = JSON.parse(data.result);                             
 
                        resolve({
                            items: items,
                            message: 'success'
                        });

                    }

                }).catch(error => {

                    console.log(error);
                    console.log('try again');
                    executeCall();

                });
            }

            executeCall();
        
        }).then((returnObject) => {
    
            commit('setGames', { items: returnObject.items });
            commit('setUserGames', { items: returnObject.items });

            commit('setLoadingBlockWars', { loading: false });

        });

    },

    newGame ({ commit }, payload) {
        return new Promise((resolve, reject) => {   

            let args = [ payload.price, payload.gridSize ];
            args = JSON.stringify(args);

            nebPay.call(contractAddress, 0, 'newGame', args, {
                listener: function(data) {
                    let hasSuccess = false;

                    const listenerCallback = function () {

                        const handleError = function (error) {

                            console.log(error);
                            clearInterval(pollApi);

                            if (error == 'Error: Transaction rejected by user' || error == 'Error: invalid argument(s)') {
                                
                                resolve({ message: 'error', item: {} });

                            } else if (!hasSuccess) {

                                console.log('error w/ getTransactionReceipt', error);
                                console.log('trying again ...');

                                listenerCallback();
                            } 

                            throw error;

                        };
                        
                        const pollApi = setInterval(() => {
                            api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {

                                if(res.status === 1) {
                                    clearInterval(pollApi);
                                    const getResult = function () {

                                        api.getEventsByHash({ hash: data.txhash })
                                        .then(function(result) {
                                            let eventData;

                                            for (let i = 0; i < result.events.length; i++) {
                                                if (result.events[i].topic == 'chain.contract.newGame') {
                                                    eventData = result.events[i].data;
                                                    break;
                                                }
                                            }

                                            let item = JSON.parse(eventData).NewGame;                                            
                                            
                                            if (!hasSuccess) {
                                                hasSuccess = true;
                                                
                                                commit('addToGames', { item });   
                                                resolve({ message: 'success', item });

                                                console.log('hasSuccess', hasSuccess);
                                            }

                                        }).catch(error => {

                                            console.log('error w/ getEventsByHash', error);
                                            console.log('trying again ...');

                                            if (!hasSuccess) {
                                                getResult();
                                            }

                                            throw error;

                                        });

                                    };

                                    // Initial
                                    getResult();

                                }

                            }).catch(error => {

                                handleError(error);

                            });
                        }, 3000);

                    };

                    listenerCallback();
                }
            });
        });
    },

    playGame ({ commit }, payload) {
        return new Promise((resolve, reject) => {    
            
            let args = [ payload.gridId, payload.blockHeadId, payload.gameId ];
            args = JSON.stringify(args);

            nebPay.call(contractAddress, payload.price, 'playGame', args, {
                listener: function(data) {
                    let hasSuccess = false;

                    const listenerCallback = function () {
                        
                        const handleError = function (error) {

                            console.log(error);
                            clearInterval(pollApi);

                            if (error == 'Error: Transaction rejected by user' || error == 'Error: invalid argument(s)') {
                                
                                resolve({ message: 'error', item: {} });

                            } else if (!hasSuccess) {

                                console.log('error w/ getTransactionReceipt', error);
                                console.log('trying again ...');

                                listenerCallback();
                            } 

                            throw error;

                        };

                        const pollApi = setInterval(() => {
                            
                            api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);
                                    const getResult = function () {

                                        api.getEventsByHash({ hash: data.txhash })
                                        .then(function(result) {
                                            let eventData;

                                            for (let i = 0; i < result.events.length; i++) {
                                                if (result.events[i].topic == 'chain.contract.playGame') {
                                                    eventData = result.events[i].data;
                                                    break;
                                                }
                                            }

                                            let item = JSON.parse(eventData).PlayGame;    
                                            
                                            if (!hasSuccess) {

                                                hasSuccess = true;

                                                commit('updateGame', { item });  
                                                commit('updateBlockhead', { 
                                                    blockWarId: item.id,
                                                    blockHeadId: payload.blockHeadId                                           
                                                });      

                                                resolve({ message: 'success', item });

                                                console.log('hasSuccess', hasSuccess);

                                            }

                                        }).catch(error => {

                                            console.log('error w/ getEventsByHash', error);
                                            console.log('trying again ...');

                                            if (!hasSuccess) {

                                                getResult();

                                            }

                                            throw error;

                                        });

                                    };

                                    // Initial
                                    getResult();

                                }
                            }).catch(error => {

                                handleError(error);

                            }); 
                    
                        }, 3000);

                    };

                    listenerCallback();
                }
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/store/actions.js